module.exports = __webpack_public_path__ + "static/img/service2.5ff8e0f4.png";